import React from "react";
import ReactDOM from "react-dom";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppBottomSheet, AppBottomSheetProps } from "./AppBottomSheet";
import { AppCheckbox } from "./AppCheckbox";

interface ParamsString {
  type: "string";
  onChange: (selectedLabels: string[]) => void;
}

interface ParamsIndexes {
  type: "indexes";
  onChange: (selectedIndexes: number[]) => void;
}

type MultipleSelectParams = ParamsString | ParamsIndexes;

export function openMultipleSelectBottomSheet(
  optionLabels: string[],
  selectedOptions: number[] | string[],
  params: MultipleSelectParams
) {
  const elem = document.createElement("div");
  elem.style.position = "absolute";
  elem.style.top = "0";
  elem.style.bottom = "0";
  elem.style.left = "0";
  elem.style.right = "0";
  elem.style.zIndex = "5";
  elem.style.overflow = "hidden";

  let selectedIndexes: number[] = [];

  if (typeof selectedOptions[0] === "string") {
    const selectedOptionsString = selectedOptions as string[];

    selectedOptionsString.forEach((curr) => {
      const foundIndex = optionLabels.indexOf(curr);

      if (foundIndex !== -1) {
        selectedIndexes.push(foundIndex);
      }
    });
  } else {
    selectedIndexes = selectedOptions as number[];
  }

  const originalCallback = params.onChange;
  const removeComponent = () => {
    ReactDOM.unmountComponentAtNode(elem);

    if (elem.parentElement !== null) {
      elem.parentElement.removeChild(elem);
    }
  };

  params.onChange = (a: any) => {
    const result = (originalCallback as any)(a);

    removeComponent();

    return result;
  };

  ReactDOM.render(
    React.createElement(AppMultipleSelectBottomSheet, {
      isOpen: true,
      optionLabels: optionLabels,
      params: params,
      selectedOptions: selectedIndexes,
      rounded: true,
      onRequestClose: removeComponent,
    }),
    elem
  );

  document.body.appendChild(elem);
}

interface AppMultipleSelectBottomSheetProps extends AppBottomSheetProps {
  optionLabels: string[];
  selectedOptions: number[];
  params: MultipleSelectParams;
}

interface AppMultipleSelectBottomSheetState {
  selectedOptions: number[];
}

class AppMultipleSelectBottomSheet extends React.Component<
  AppMultipleSelectBottomSheetProps,
  AppMultipleSelectBottomSheetState
> {
  constructor(props: AppMultipleSelectBottomSheetProps) {
    super(props);

    const selectedOptionsInit: number[] = [];

    this.props.selectedOptions.forEach((curr) => selectedOptionsInit.push(curr));

    this.state = {
      selectedOptions: selectedOptionsInit,
    };
  }

  selectIndex(index: number) {
    const foundIndex = this.state.selectedOptions.indexOf(index);

    if (foundIndex === -1) {
      this.setState((state) => {
        state.selectedOptions.push(index);
        return state;
      });
    } else {
      this.setState((state) => {
        state.selectedOptions.splice(foundIndex, 1);
        return state;
      });
    }
  }

  submit() {
    switch (this.props.params.type) {
      case "string": {
        const selectedLabels: string[] = [];

        this.state.selectedOptions.forEach((curr) =>
          selectedLabels.push(this.props.optionLabels[curr])
        );

        return this.props.params.onChange(selectedLabels);
      }
      case "indexes": {
        return this.props.params.onChange(this.state.selectedOptions);
      }
      default: {
        // do nothing
      }
    }
  }

  render() {
    return (
      <AppBottomSheet {...this.props}>
        <div className="AppMultipleSelectBottomSheet_container">
          {this.props.optionLabels.map((curr, index) => {
            return (
              <div
                className="AppMultipleSelectBottomSheet_row"
                key={"option-" + curr}
                onClick={() => this.selectIndex(index)}
              >
                <div className="AppMultipleSelectBottomSheet_label">{curr}</div>
                <span style={{ flexGrow: 1 }} />
                <div className="AppMultipleSelectBottomSheet_checkboxContainer">
                  <AppCheckbox
                    checked={
                      this.state.selectedOptions.indexOf(this.props.optionLabels.indexOf(curr)) !==
                      -1
                    }
                  />
                </div>
              </div>
            );
          })}
          <div className="AppMultipleSelectBottomSheet_submitButton" onClick={() => this.submit()}>
            {translate(STRINGS.SUBMIT)}
          </div>
        </div>
      </AppBottomSheet>
    );
  }
}
